// import { ProjectFieldsName } from 'routes/projects/list-v2/fields';
import { unreachable } from 'module/helpers/unreachable';
import { FieldType } from 'module/types/filter-field/field/field';
import { BooleanFieldFilter } from 'module/types/filter-field/filter/boolean';
import { DateFieldFilter } from 'module/types/filter-field/filter/date';
import { EstimateFieldFilter } from 'module/types/filter-field/filter/estimate';
import { FieldFilter } from 'module/types/filter-field/filter/index';
// import { assignee } from './assignee';
import { MultiSelectFieldFilter } from 'module/types/filter-field/filter/multi-select';
import { MultiUserFieldFilter } from 'module/types/filter-field/filter/multi-user';
import { NumberFieldFilter } from 'module/types/filter-field/filter/number';
import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import { TextFieldFilter } from 'module/types/filter-field/filter/text';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { boolean } from './boolean';
// import { currency } from './currency';
import { date } from './date';
import { estimate } from './estimate';
import { multi_select } from './multi-select';
import { multi_user } from './multi-user';
import { number } from './number';
// import { numberOfPeriods } from './number-of-periods';
// import { project_phase } from './project-phase';
// import { project_budget } from './project_budget';
import { single_select } from './single-select';
import { single_user } from './single-user';
// import { task_dependency_status } from './task_dependency_status';
import { text } from './text';
// import { AssigneeFieldFilter } from '../filters/assignee';

export const toFilterFunction = (filter: FieldFilter): FilterFunction => {
  // if (filter.field.fieldName === 'projectPhaseId') {
  //   return project_phase(filter as SingleSelectFieldFilter);
  // }
  // if (filter.field.fieldName === 'taskDependencyStatus') {
  //   return task_dependency_status(filter as SingleSelectFieldFilter);
  // }
  // if (filter.field.fieldName === ProjectFieldsName.projectBudget) {
  //   return project_budget(filter as NumberFieldFilter);
  // }
  // if (filter.field.fieldName === ProjectFieldsName.currency) {
  //   return currency(filter as SingleSelectFieldFilter);
  // }
  // if (filter.field.fieldName === ProjectFieldsName.numberOfPeriods) {
  //   return numberOfPeriods(filter as NumberFieldFilter);
  // }
  switch (filter.field.type) {
    case FieldType.Boolean:
      return boolean(filter as BooleanFieldFilter);
    case FieldType.Number:
      return number(filter as NumberFieldFilter);
    case FieldType.Text:
    case FieldType.MultiLineText:
      return text(filter as TextFieldFilter);
    case FieldType.Date:
      return date(filter as DateFieldFilter);
    case FieldType.SingleSelect:
      return single_select(filter as SingleSelectFieldFilter);
    case FieldType.MultiSelect:
      return multi_select(filter as MultiSelectFieldFilter);
    case FieldType.SingleUser:
      return single_user(filter as SingleUserFieldFilter);
    case FieldType.MultiUser:
      return multi_user(filter as MultiUserFieldFilter);
    // case FieldType.Assignee:
    //   return assignee(filter as AssigneeFieldFilter);
    case FieldType.Estimate:
      return estimate(filter as EstimateFieldFilter);
    case FieldType.Note:
      return () => true; // using placeholder value as this filter is only used in unpaginated view, and it has been deprecated
    default:
      return unreachable(filter.field as never);
  }
};
